import { render, staticRenderFns } from "./VideoComponent.vue?vue&type=template&id=7f263e58"
import script from "./VideoComponent.vue?vue&type=script&lang=ts"
export * from "./VideoComponent.vue?vue&type=script&lang=ts"
import style0 from "./VideoComponent.vue?vue&type=style&index=0&id=7f263e58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports